import { createSelector } from 'reselect';
import { NAMESPACE } from './constants';
import { initialState } from './reducer';

const selectRefreshWebchatDomain = state => state[NAMESPACE] || initialState;

const selectWebchatNextPosition = () =>
    createSelector(selectRefreshWebchatDomain, state => state.response.nextPosition || 1);

const selectWebchatResponse = () =>
    createSelector(selectRefreshWebchatDomain, state => state.response.messages);

const selectWebChatEnded = () =>
    createSelector(selectRefreshWebchatDomain, state => state.response.chatEnded);

const selectError = () =>
    createSelector(selectRefreshWebchatDomain, state => state.error);

const selectAgentTakeOver = () =>
    createSelector(selectRefreshWebchatDomain, state => state.agent);

export {
    selectWebchatNextPosition,
    selectWebchatResponse,
    selectWebChatEnded,
    selectError,
    selectAgentTakeOver,
};
